@if (availableTypesSelectionList(); as availableTypesSelectionList) { @if (availableTypesSelectionList.length > 1) {

<div class="push-bottom">
	<div libFlexRow>
		<div libFlexColumn libFlexFill>
			<ui-select-item-field
				[design]="'card'"
				[placeholder]="'Select type...'"
				[isRequired]="true"
				[valueAsSignal]="selectedTypeId"
				[items]="availableTypesSelectionList"
			></ui-select-item-field>
		</div>
	</div>
</div>

} @else {
<div></div>
} } @if (selectedType(); as selectedType) { @if (overviewTableItems(); as overviewTableItems) {
<lib-card [title]="'Overview'" class="push-bottom">
	<ui-info-table [items]="overviewTableItems"></ui-info-table>
</lib-card>
}

<lib-card [title]="'Graph'" class="push-bottom">
	<lib-line-chart
		[multiSeries]="selectedType.multiSeries"
		[xAxisLabel]="selectedType.xLabel ?? 'Date'"
		[yAxisLabel]="selectedType.yLabel ?? 'Value'"
	></lib-line-chart>
</lib-card>
} @if (table(); as table) {
<lib-card [title]="'Recorded data'" class="push-bottom">
	@if (isMobileView()) { @if (measurementsInfoTableItems(); as measurementsInfoTableItems) {
	<ui-info-table [items]="measurementsInfoTableItems"></ui-info-table>
	}} @else {
	<lib-table [table]="table"></lib-table>
	}
</lib-card>
}
